import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useMemberStaleAwareData } from '../../Context/useMemberStaleAwareData';
import Icon from '../../common/Icon';
import { NotificationBannerItem } from '../NotificationBanner';
import { useMembershipInfoContext } from '../../Context/MembershipInfoContext';
import { getCompanyTypeName } from '../../my-account/my-details/my-account-utils';
import { checkShowCompanyNumber } from '../../my-account/my-details/CompanyDetailsForm';

const useAccountReviewAlert = () => {
  const navigate = useNavigate();
  const { data } = useMemberStaleAwareData();
  const { referenceTypes } = useMembershipInfoContext();

  const [alerts, setAlerts] = useState<NotificationBannerItem[]>([]);

  const isEmpty = (value?: string) => !value || value.trim() === '';

  const calculateAlerts = useCallback((): NotificationBannerItem[] => {
    if (!data) return [];

    const companyTypeName = getCompanyTypeName(
      data.companyTypeId,
      referenceTypes.companyType
    );

    const mustHaveCompanyRegistrationOrCharityNumber = () : boolean=> {
      const needsCompanyNumber = checkShowCompanyNumber(companyTypeName)
      if (needsCompanyNumber)
        return isEmpty(data.companyRegistrationOrCharityNumber)

      return false;
    }

    const shouldShowAlert =
      mustHaveCompanyRegistrationOrCharityNumber() ||
      data.localAuthority?.id === "00000000-0000-0000-0000-000000000000" ||
      isEmpty(data.invoiceAddress?.town) ||
      isEmpty(data.invoiceAddress?.county) ||
      isEmpty(data.invoiceAddress?.postCode) ||
      isEmpty(data.mailingAddress?.town) ||
      isEmpty(data.mailingAddress?.county) ||
      isEmpty(data.mailingAddress?.postCode);
      
    if (!shouldShowAlert) return [];

    return [
      {
        highlight: false,
        status: 'amber',
        icon: <Icon name="information" color="#E0BC00" />,
        text: 'Your account details may be missing important information',
        buttonText: 'Review',
        onButtonClick: () => navigate('/myaccount/details'),
      },
    ];
  }, [data, referenceTypes, navigate]);

  const refresh = useCallback(() => {
    setAlerts(calculateAlerts());
  }, [calculateAlerts]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { alerts, refresh };
};

export default useAccountReviewAlert;